export enum SizeType {
    ExtraSmall = "xs",
    Small = "sm",
    Base = "base",
    Large = "lg",
    ExtraLarge = "xl",
    ExtraLarge2 = "2xl",
}

export function OnlyBiggerThanBase(value: SizeType): SizeType {
    // @todo optimize this function
    for (const sizeKey of Object.keys(SizeType)) {
        const size = SizeType[sizeKey];

        if (size === value) {
            return SizeType.Base;
        } else if (size === SizeType.Base) {
            break;
        }
    }

    return value;
}
